<template>
  <div class="cilinder-picker" :class="{ mobile: device === 'mobile' }">
    <div class="toggle-container">
      <span class="heading">{{ $t('cylinder.list.attachment') }}: {{ getTypeName }}</span>
      <form class="radio-container">
        <input type="radio" :value="1" v-model="cilinderFilter" name="filter" id="recommended"
               checked="checked">
        <label for="recommended">
          {{ $t('cylinder.list.recommended') }}
        </label>
        <input type="radio" :value="2" v-model="cilinderFilter" name="filter" id="all">
        <label for="all">
          {{ $t('cylinder.list.showAll') }}
        </label>
      </form>
    </div>
    <div class="cilinder-table">
      <div class="table-header">
        <div class="selection">{{ $t('cylinder.list.select') }}</div>
        <div class="piston_al" @click="sort('piston_al')" :class="[sortBy === 'piston_al' ? sortDirection : '']">{{ $t('cylinder.list.piston') }}</div>
        <div class="rod_s" @click="sort('rod_s')" :class="[sortBy === 'rod_s' ? sortDirection : '']">{{ $t('cylinder.list.rod') }}</div>
        <div class="stroke_k" @click="sort('stroke_k')" :class="[sortBy === 'stroke_k' ? sortDirection : '']">{{ $t('cylinder.list.stroke') }}</div>
        <div class="attachment" @click="sort('attachment_id')" :class="[sortBy === 'attachment_id' ? sortDirection : '']">{{ $t('cylinder.list.attachment') }}</div>
        <div class="supply" @click="sort('stock')" :class="[sortBy === 'stock' ? sortDirection : '']">{{ $t('cylinder.list.deliveryTime') }}</div>
        <div class="price" @click="sort('price')" :class="[sortBy === 'price' ? sortDirection : '']">{{ $t('cylinder.list.price') }}</div>
        <div class="amount-table">{{ $t('cylinder.list.amount') }}</div>
        <div class="actions">
          <button v-if="filterByClosest.length > 0" type="button" class="btn btn-success btn-invoice"
                  @click="invoicePopup = !invoicePopup">
            {{ $t('cylinder.list.requestQuotation') }}
          </button>
        </div>
      </div>
      <div class="custom-cilinder" v-if="filterByClosest < 1 && !loading">
        <div class="custom-label">{{ $t('cylinder.list.noConfiguration') }}</div>
        <div class="cart-action">
          <button type="button" class="btn btn-success btn-invoice" @click="invoicePopup = !invoicePopup">
            {{ $t('cylinder.list.attachment') }}
          </button>
        </div>
      </div>
      <div v-if="loading" class="cylinder-loader"><div></div></div>
      <LazyList
          :data="sortedType"
          :itemsPerRender="15"
          container-classes="cilinder-list"
      >
        <template v-slot="{item}">
          <cilinder :cilinder="item" :key="`cilinder${item.id}`"
                    @openModal="$emit('openModal')"></cilinder>
        </template>
      </LazyList>
      <popup-invoice v-if="invoicePopup" @close="invoicePopup = false">
      </popup-invoice>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import Cilinder from "./Cilinder";
import PopupInvoice from "@/components/popup/PopupInvoice";
import LazyList from "@/components/LazyList.vue";

export default {
  name: "CilinderList",

  components: {
    PopupInvoice,
    Cilinder,
    LazyList,
  },

  data() {
    return {
      invoicePopup: false,
      noScroll: false,
      sortBy: null,
      sortDirection: 'asc',
      loading: false,
    }
  },

  computed: {
    ...mapState({
      cilinders: state => state.cilinders.all,
      cilinderFilterState: state => state.preference.cilinderFilter,
    }),
    ...mapGetters({
      type: 'preference/getCilinderType',
      circuit: 'preference/getCilinderCircuit',
      cilinderOptions: 'preference/getCilinderOptions',
      selectedCilinder: 'preference/getSelectedCilinder',
      device: 'getDevice',
    }),
    cilinderFilter: {
      get() {
        return this.cilinderFilterState;
      },
      set(val) {
        this.$store.commit('preference/setCilinderFilter', val);
      }
    },
    getTypeName() {
      if (this.$store.getters["preference/getCilinderTypeName"] === 'Alle bevestigingen') {
        return this.$store.getters["preference/getCilinderTypeName"]
      } else {
        return this.translate(this.$store.getters["preference/getCilinderTypeName"]);
      }
    },
    sortedType() {
      if (this.sortBy) {
        return this.sortedCilinders;
      } else {
        return this.filterByClosest;
      }
    },
    sortedCilinders: function(){
      return this.filterByClosest.sort((p1,p2) => {
        let modifier = 1;
        if(this.sortDirection === 'desc') modifier = -1;
        if(p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier;
        if(p1[this.sortBy] > p2[this.sortBy]) return 1 * modifier;
        return 0;
      });
    },
    filterByClosest() {
      if (!this.cilinders.length > 0) return this.cilinders;
      let circuit = this.circuit;
      let type = this.cilinderOptions.type;
      let array = this.cilinders;

      if (this.cilinderFilter === 2) return array.filter(function (cilinder) {
        return (cilinder.attachment_id === type || type === 0) &&
            cilinder.type === circuit
      });

      const length = this.cilinders.length;
      let pistonDiameter = {previous: 0, next: 9999};
      let strokeK = {previous: 0, next: 9999};

      //Define minimum and maximum of values
      for (let i = 0; i < length; i++) {
        let c = this.cilinders[i];
        if (c.type !== circuit || (c.attachment_id !== type && type !== 0)) continue;
        if (pistonDiameter.previous < c.piston_al && c.piston_al < this.cilinderOptions.pistonDiameter) pistonDiameter.previous = c.piston_al;
        if (pistonDiameter.next > c.piston_al && c.piston_al > this.cilinderOptions.pistonDiameter) pistonDiameter.next = c.piston_al;

        if (strokeK.previous < c.stroke_k && c.stroke_k < this.cilinderOptions.stroke) strokeK.previous = c.stroke_k;
        if (strokeK.next > c.stroke_k && c.stroke_k > this.cilinderOptions.stroke) strokeK.next = c.stroke_k;
      }
      if (this.cilinderOptions.type === 0) return array.filter(function (cilinder) {
        return cilinder.type === circuit &&
            ((cilinder.piston_al >= pistonDiameter.previous &&
                cilinder.piston_al <= pistonDiameter.next) &&
                (cilinder.stroke_k >= strokeK.previous &&
                    cilinder.stroke_k <= strokeK.next));
      });
      //Filter cilinders based on min and max
      return array.filter(function (cilinder) {
        return cilinder.attachment_id === type &&
            cilinder.type === circuit &&
            ((cilinder.piston_al >= pistonDiameter.previous &&
                cilinder.piston_al <= pistonDiameter.next) &&
                (cilinder.stroke_k >= strokeK.previous &&
                    cilinder.stroke_k <= strokeK.next));
      });
    },
    availableCilinders() {
      if (!this.cilinders.length > 0) return this.cilinders;
      let circuit = this.circuit;
      let type = this.cilinderOptions.type;
      let array = this.cilinders;
      array.filter(function (cilinder) {
        return cilinder.attachment_id === type &&
            cilinder.type === circuit;
      });
      return array;
    },
  },

  methods: {
    setScroll(val) {
      return this.noScroll = val;
    },
    sort: function(s){
      if(s === this.sortBy) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      }
      this.sortBy = s;
    }
  },
  created() {
    if(this.cilinderOptions.stroke !== 0 || this.cilinderOptions.pistonDiameter !== 0 || this.cilinderOptions.rodDiameter !== 0) {
      this.cilinderFilter = 1;
    }
    if (this.cilinderOptions.rodDiameter === 0 && this.cilinderOptions.pistonDiameter === 0 && this.cilinderOptions.stroke === 0) {
      this.cilinderFilter = 2;
    } else if (this.cilinderOptions.rodDiameter !== 0 || this.cilinderOptions.pistonDiameter !== 0 || this.cilinderOptions.stroke !== 0) {
      this.cilinderFilter = 1;
    }
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch('cilinders/index').finally(() => {
      this.loading = false;
    });
  }
}
</script>

<style lang="scss">
.cilinder-picker {
  margin: 20px auto 0;

  &.mobile {
    .cilinder-table {
      overflow-x: auto;
      overflow-y: auto;
      margin-bottom: 24px;
      min-width: 100%;

      .table-header {
        min-width: 1100px;
      }

      .cilinder-list {
        min-width: 1100px;
        overflow-y: unset;
      }
    }
  }

  .heading {
    font-size: 12px;
    padding: 16px 20px 5px 15px;
    font-family: neue-haas-grotesk-display, sans-serif;
    font-style: normal;
    font-weight: 700;
    /*box-shadow: 0 0 10px #d3d3d3;*/
  }

  .more {
    width: 100%;
    text-align: center;
    margin-top: 10px;

    .link {
      text-decoration: underline;
      padding: 10px 10px 0 0;
      cursor: pointer;
      transition: all ease 0.2s;

      &:hover {
        color: #3DB0C7;
      }
    }

    .icon {
      transform: scale(1.2) rotate(90deg);
    }
  }
}

.scrollable {
  margin: 0;
  width: 806px;

  .invoice {
    background-color: #d2d2d2;
  }
}

.cilinder-table {
  background: #f0f0f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06);
  font-size: 12px;
  position: relative;
  margin-top: 15px;
  overflow-x: auto;

  .table-header {
    div {
      &.piston_al,
      &.rod_s,
      &.stroke_k,
      &.attachment,
      &.price,
      &.supply {
        cursor: pointer;
      }
      &.asc:after{
        content: "\25B2";
        color: #3DB0C7;
      }

      &.desc:after{
        content: "\25BC";
        color: #3DB0C7;
      }
    }
  }

  .table-header,
  .custom-cilinder,
  .cilinder-row {
    display: grid;
    grid-template-columns: 40px 80px 80px 80px 240px 140px 100px 100px 187px;

    &.selected {
      background-color: lighten(#3db0c7, 30%);
    }

    .download-link {
      border: none !important;
      background: transparent !important;
      display: inline-block;
      position: relative;
      right: 15%;
      transition: all ease 0.3s;

      &:hover {
        transform: scale(1.1);
        filter: brightness(200%);
      }

      img {
        max-height: 24px;
        max-width: 24px;
      }
    }

    .selection,
    .piston_al,
    .rod_s,
    .stroke_k,
    .attachment,
    .supply,
    .amount-table,
    .price {
      padding: 3px 3px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 2px solid #e0e0e0;
    }

    .attachment {
      .cilinder-render {
        max-width: 100%;
        height: auto;
        position: relative;
        left: 10%;
        mix-blend-mode: multiply;
      }
    }

    .cart-action,
    .actions {
      display: flex;
      align-items: center;
      padding: 3px 3px;
      margin-left: 10px;

      .btn {
        color: white;
        padding: 3px 10px !important;
        font-size: 11px;
        height: 24px;
        border-radius: 15px;
        font-weight: bold;
        border: transparent;

        &.btn-success {
          background: #71bc03;

          &:hover {
            background: darken(#71bc03, 10%);
          }
        }

        &.blue {
          background: #3db0c7;
          flex-grow: 1;
          margin-right: 10px;

          &:hover {
            background: darken(#3db0c7, 10%);
          }

          &.active {
            background-color: darken(#3db0c7, 15%);
          }
        }

        img {
          max-height: 13px;
          max-width: 13px;
          margin-right: 5px;
        }
      }
    }
  }

  .table-header {
    background: #f5f5f5;
    font-family: neue-haas-grotesk-display, sans-serif;
    font-size: 11px;
    font-weight: 700;
  }

  .custom-cilinder {
    .custom-label {
      grid-column-start: 1;
      grid-column-end: 9;
      padding: 15px;
      background: #e0e0e0;
      text-align: center;
    }

    .cart-action {
      background: #e0e0e0;
      text-align: center;

      button.btn {
        min-width: 175px;
      }
    }
  }

  .cilinder-list {
    max-height: 320px;
    overflow-y: auto;
    position: relative;

    .cilinder-row {
      &:nth-child(odd) {
        background-color: #F0F0F0;
      }

      &:nth-child(even) {
        background-color: #F5F5F5;
      }
    }
  }

  &:after {
    content: "";
    position: absolute;
    display: block;
    height: 10px;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: linear-gradient(transparentize(#e0e0e0, 1), transparentize(#e0e0e0, 0.5));
  }
}

.toggle-container {
  align-items: center;
  text-align: center;
  justify-content: space-between;
  height: 50px;
  display: flex;

  .heading {
    padding: 0;
  }

  .radio-container {
    border-radius: 50px;
    border: 2px solid #EBEBEB;
    height: 40px;
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background-color: white;
    transition: all ease 0.3s;

    @media only screen and (max-width: 375px) {
      label {
        white-space: nowrap;
      }
    }

    label {
      cursor: pointer;
      display: flex;
      justify-content: center;
      font-size: 12px;
      margin: 0;
      border-radius: 25px;
      width: 50%;
      padding: 9px;
      user-select: none;
      font-family: neue-haas-grotesk-display, sans-serif;
    }

    input[type="radio"] {
      display: none;


      &:checked + label {
        background-color: #3DB0C7;
        color: white;
      }
    }
  }
}

.invoice {
  .btn-invoice {
    display: flex;
    border-radius: 50px;
    text-transform: capitalize;
    color: white;
    border: none;
    height: 23px;
    align-content: center;
    justify-content: space-evenly;
    align-items: center;
    width: 118px;
    margin: auto;
    font-size: 11px;
    font-family: neue-haas-grotesk-display, sans-serif;
    transition: all ease 0.3s;
    letter-spacing: 0.5px;
    background-color: #71BC03;
    outline: none;

    &:hover {
      background-color: darken(#71BC03, 10%);
      color: white;
    }
  }
}

.cylinder-loader {
  display: flex;
  justify-content: center;
  position: relative;
  height: 80px;
  margin: 10px 0;
}
.cylinder-loader div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #3DB0C7;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #3DB0C7 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.cilinder-list{
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 320px;
  position: relative;
}

</style>
